/**
 * Convert a string to a URL-safe slug for use in subdomains
 * @param text - The text to convert to a slug
 * @returns A lowercase, URL-safe slug
 */
export const slugify = (text: string): string => {
  if (!text) return '';

  return (
    text
      .toLowerCase()
      .trim()
      // Remove all non-alphanumeric characters
      .replace(/[^a-z0-9]/g, '')
  );
};
